import styles from './BackgroundSVG.module.css';

const BackgroundSVG = () => {
  return <div className={styles.backSVGContainer}></div>;
};

export default BackgroundSVG;
